'use strict'
// Template version: 1.2.8
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')
const configVue = require(__dirname + '/../src/config/Settings.js')

var configBuild = {
  dev: {

    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},

    // Various Dev Server settings
    // origin
    host: '0.0.0.0', // can be overwritten by process.env.HOST
		// end origin
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-


    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true,
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}

// origin
configBuild.build.index = path.resolve(__dirname, configVue.dist.root, configVue.dist.subfolder, 'index.html')
configBuild.build.assetsRoot = path.resolve(__dirname, configVue.dist.root, configVue.dist.subfolder)
configBuild.build.assetsPublicPath = path.join('/', configVue.dist.subfolder, '/')

if(configVue.localAssets)
  configBuild.build.assetsPublicPath = './'

if(configVue.cms) {
  configBuild.build.index = path.resolve(__dirname, '../../public/vue.html')
  configBuild.build.assetsRoot = path.resolve(__dirname, '../../public')

  var segments = [
    '/' + configVue.ADMIN_PREFIX,
    '/' + configVue.API_PREFIX,
  ]

  segments.forEach(function(o) {
    configBuild.dev.proxyTable[o] = {
      target: configVue.BASE_URL,
      changeOrigin: true,
    }
  })
}
// end origin

module.exports = configBuild



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 0